// Build/version info baked into the bundle.
// VUE_APP_BUILD_ID is set by the CI workflow (short git sha + timestamp); 'dev' locally.
import { version as pkgVersion } from '../../package.json'

export const APP_VERSION = process.env.VUE_APP_VERSION || pkgVersion
export const BUILD_ID = process.env.VUE_APP_BUILD_ID || 'dev'